// src/components/partners/CircularAccessBar.jsx
import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

const CircularAccessBar = ({
  text = "Circular Comunidad",
  logoSrc = "/assets/circular-logo-bar.png",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        backgroundColor: "rgba(160, 28, 186, 0.82)", // 👈 más oscuro
        borderBottom: "1px solid rgba(0,0,0,0.18)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center", // logo + texto centrados desktop y mobile
          gap: 1.5,
          py: 0.25,
          px: 2,
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt="Circular"
          sx={{
            width: isMobile ? 20 : 24,
            height: "auto",
            flexShrink: 0,
          }}
        />
        <Typography
          variant={isMobile ? "body2" : "body1"}
          sx={{
            color: theme.palette.grey[100],
            fontWeight: 500,
            textAlign: "center",
            whiteSpace: "nowrap",
            letterSpacing: 0.5,
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularAccessBar;
